export const COLOR_NAME_MAX_LENGTH = 50;

export const normalizeColorName = (name: unknown): string | undefined => {
  if (typeof name !== "string") return undefined;
  const trimmed = name.trim().slice(0, COLOR_NAME_MAX_LENGTH);
  return trimmed === "" ? undefined : trimmed;
};
